import classNames from 'classnames';
import { DetailedHTMLProps, FC, HTMLAttributes, useContext } from 'react';

import { ButtonSizes, ButtonVariant, ExternalImgPath, Icon, Image, LinkAsButton, Typography } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';

import AuthContext from '@/contexts/Auth/AuthContext';

import './NewsCard.scss';

interface NewsCardMobileProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  id: string;
  className?: string;
  title: string;
  image: Nullable<string>;
  date: string | Date;
  to?: string;
}

export const NewsCard: FC<NewsCardMobileProps> = ({ className, image, title, date, to, ...restProps }) => {
  const { storedLinks } = useContext(AuthContext);

  const imageSrc = image && storedLinks?.app?._baseUrl ? `${storedLinks.app._baseUrl}${image}` : undefined;
  const defaultImageSrc = '/images/news_no_photo.webp';
  const finalImageSrc = (imageSrc || defaultImageSrc) as ExternalImgPath;

  return (
    <div className={classNames('news-card', className)} {...restProps}>
      <div className="news-card__image-wrapper">
        <Image src={finalImageSrc} alt={title} className="news-card__image" fallback={defaultImageSrc} />
      </div>
      <div className="news-card__content">
        <div className="news-card__date-wrapper">
          <Typography color="graphite" variant="TEXT10">
            {formatDate(date, '.', false, true)}
          </Typography>
        </div>
        <Typography className="news-card__title" variant="TEXT16">
          {title}
        </Typography>
        {to && (
          <LinkAsButton to={to} variant={ButtonVariant.GHOST} size={ButtonSizes.SM} className="news-card__read-button">
            Читати
            <Icon name="arrow_forward" />
          </LinkAsButton>
        )}
      </div>
    </div>
  );
};
